import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-navfooter',
  templateUrl: './mobile-navfooter.component.html',
  styleUrls: ['./mobile-navfooter.component.css']
})
export class MobileNavfooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
